import { auth, db } from './Firebase'

const getData = async (collection) => {
  data[collection].unregister()
  try {
    await db.collection(collection).get().then(snapshot => {
      const docs:{_id: string}[] = []
      if (snapshot.size) {
        snapshot.forEach(doc => {
          docs.push({_id: doc.id, ...doc.data()})
        })
      }
      return docs
    })
  } catch (err) {
    throw err
  }
}

const data = {
  applications: {
    data: [] as any[],
    unregister: () => null
  },
  cameras: {
    data: [] as any[],
    unregister: () => null
  },
  'cameras_cameras': {
    data: [] as any[],
    unregister: () => null
  },
  clients: {
    data: [] as any[],
    unregister: () => null
  },
  edits: {
    data: [] as any[],
    unregister: () => null
  },
  locations: {
    data: [] as any[],
    unregister: () => null
  },
  maps: {
    data: [] as any[],
    unregister: () => null
  },
  partners: {
    data: [] as any[],
    unregister: () => null
  },
  projects: {
    data: [] as any[],
    unregister: () => null
  },
  systems: {
    data: [] as any[],
    unregister: () => null
  },
  users: {
    data: [] as any[],
    unregister: () => null
  },
  videos: {
    data: [] as any[],
    unregister: () => null
  },
  views: {
    data: [] as any[],
    unregister: () => null
  }
}

const userHasReadPermission = (permission, permissions) => {
  return permissions.indexOf(permission) > -1
} 

auth.onAuthStateChanged(async user => {
  if (user) {
    try {
      const token = await user.getIdTokenResult()
      const claims = token.claims
      if (claims.super) {
        Object.keys(data).forEach(async collection => {
          try {
            data[collection].unregister()
            await db.collection(collection).get().then(snapshot => {
              const docs:{_id: string}[] = []
              if (snapshot.size) {
                snapshot.forEach(doc => {
                  docs.push({_id: doc.id, ...doc.data()})
                })
              }
              data[collection].data = docs
            })
          } catch (err) {
            throw err
          }
        })
      } else if (claims.partner) {
        Object.keys(data).forEach(async collection => {
          if (userHasReadPermission(`read:${collection}`, claims.permissions)) {
            try {
              await db.collection(collection)
              .where("partners", "array-contains", claims.partner)
              .get().then(snapshot => {
                const docs:{_id: string}[] = []
                if (snapshot.size) {
                  snapshot.forEach(doc => {
                    docs.push({_id: doc.id, ...doc.data()})
                  })
                }
                data[collection].data = docs
              })
            } catch (err) {
              throw err
            }
          }
        })
      } else if (claims.client) {
        Object.keys(data).forEach(async collection => {
          if (userHasReadPermission(`read:${collection}`, claims.permissions)) {
            try {
              await db.collection(collection)
              .where("clients", "array-contains", claims.client)
              .get().then(snapshot => {
                const docs:{_id: string}[] = []
                if (snapshot.size) {
                  snapshot.forEach(doc => {
                    docs.push({_id: doc.id, ...doc.data()})
                  })
                }
                data[collection].data = docs
              })
            } catch (err) {
              throw err
            }
          }
        })
      } else {
        Object.keys(data).forEach(async collection => {
          if (userHasReadPermission(`read:${collection}`, claims.permissions)) {
            try {
              await db.collection(collection)
              .where("users", "array-contains", user.uid)
              .get().then(snapshot => {
                const docs:{_id: string}[] = []
                if (snapshot.size) {
                  snapshot.forEach(doc => {
                    docs.push({_id: doc.id, ...doc.data()})
                  })
                }
                data[collection].data = docs
              })
            } catch (err) {
              throw err
            }
          }
        })
      }

    } catch (err) {
      alert(err.message)
    }
  }
})

export default {
  install(Vue) {
    Vue.prototype.$_data = data
  }
}
